import React from 'react';
import Italy, { getItalyDefaults } from './Italy';
import { validateField } from './validate';
import * as styles from './style.module.css';

export default function AdditionalInfo({cache, setCache, address}) {
    const additionalInformation = cache.additional_information;

    const updateField = e => {
        setCache({
            ...cache,
            additional_information: {
                ...additionalInformation,
                [e.target.name]: e.target.value
            }
        });
        validateField(e.target);
    }

    return (
        <div className={styles.additionalInfo}>
            <CountrySwitcher address={address} data={additionalInformation} updater={updateField} />
        </div>
    );
}

function CountrySwitcher({address, data, updater}) {
    switch (address?.country_code) {
        case 'IT':
            return <Italy data={data} update={updater} />;
    }
    return null;
}


export function getDefaults(saved, address) {
    switch (address?.country_code) {
        case 'IT':
            return getItalyDefaults(saved);
    }
    return {};
}
